/**
 * Lets Mixpanel read the header organization list without auth-store importing
 * app-store. That static import closed a cycle through the organization barrel
 * and left OrganizationStatusCode undefined while app-store was still loading.
 * app-store registers a live reader after it has finished initializing.
 */

type MixpanelOrganizationRef = {
	id: string;
	name?: string | null;
};

export type MixpanelOrgSource = {
	availableOrganizations: readonly MixpanelOrganizationRef[];
	currentApp: "main" | "admin" | "org-admin";
	currentOrganization: MixpanelOrganizationRef | null;
};

const emptyMixpanelOrgSource: MixpanelOrgSource = {
	availableOrganizations: [],
	currentApp: "main",
	currentOrganization: null,
};

let readMixpanelOrgSource = (): MixpanelOrgSource => emptyMixpanelOrgSource;

export function registerMixpanelOrgSource(read: () => MixpanelOrgSource): void {
	readMixpanelOrgSource = read;
}

export function getMixpanelOrgSource(): MixpanelOrgSource {
	return readMixpanelOrgSource();
}
